import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AutoLogoutService } from '@core/services/auto-logout.service';

@Component({
  selector: 'napa-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  constructor(private autoLogoutService: AutoLogoutService) {
    this.autoLogoutService.trackActivity();
  }
}
